import { useMutation } from '@apollo/client';
import { DELETE_CREATIVE_PROJECT } from '../../graphql/mutations/creativeMutations';

/**
 * Hook to delete a Creative Project
 * @returns {object} - { handleDeleteProject, loading, error }
 */
export const useDeleteCreativeProject = () => {
  const [deleteProjectMutation, { loading, error }] = useMutation(DELETE_CREATIVE_PROJECT, {
    refetchQueries: ['CreativeProjectsByCreativeID', 'GetCreative'],
    awaitRefetchQueries: true
  });

  const sanitizeInput = (input = {}) => {
    const cleaned = { ...input };
    Object.keys(cleaned).forEach((key) => {
      if (cleaned[key] === undefined) {
        delete cleaned[key];
      }
    });
    return cleaned;
  };

  const handleDeleteProject = async (projectData) => {
    try {
      if (!projectData?.id) {
        throw new Error('Das Projekt konnte nicht zugeordnet werden. Bitte lade die Seite neu und versuche es erneut.');
      }

      const input = sanitizeInput({
        id: projectData.id
      });

      const variables = sanitizeInput({
        input,
        condition: projectData?.condition
      });

      const { data: projectResponse } = await deleteProjectMutation({
        variables
      });

      return projectResponse?.deleteCreativeProject;
    } catch (error) {
      console.error('Error deleting creative project:', error);
      throw error;
    }
  };

  return {
    handleDeleteProject,
    loading,
    error
  };
};
